module.exports = __webpack_public_path__ + "assets/img/form-verification-logo.ec97ba6f.png";